import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import VideocamIcon from '@material-ui/icons/Videocam';
import { TableVirtuoso } from 'react-virtuoso';
import VehicleTableCms from 'src/app/components/tables/VehicleTableCms';
import { titleTableHeader } from 'src/app/components/tables/constance';
import {
  buildStreamKey,
  getMaxCameraCount,
  getVehicleTimestamp
} from '../helpers';

const CameraQuickButton = ({ active, channel, onClick }) => (
  <button
    type="button"
    className={`cms-camera-quick-button ${active ? 'active' : ''}`}
    onMouseDown={event => {
      event.stopPropagation();
      event.preventDefault();
    }}
    onClick={event => {
      event.stopPropagation();
      event.preventDefault();
      onClick();
    }}
  >
    {channel}
  </button>
);

const CameraVehicleTable = React.memo(({
  vehicles,
  isLoading,
  selectedVehicleId,
  onSelectVehicle,
  findStreamIndex,
  toggleStream
}) => (
  <Box className="cms-camera-table-shell">
    {isLoading ? (
      <Box className="cms-camera-empty-state">
        <CircularProgress size={28} />
      </Box>
    ) : vehicles.length ? (
      <TableVirtuoso
        style={{ flex: 1, width: '100%' }}
        data={vehicles}
        components={{
          Table: props => (
            <table
              {...props}
              style={{
                ...props.style,
                borderCollapse: 'collapse',
                border: '1px solid rgba(60, 64, 67, 0.15)',
                backgroundColor: '#f5f5f5',
                tableLayout: 'fixed',
                width: '100%'
              }}
            />
          ),
          TableRow: ({ item, ...props }) => {
            const isActive = item.device_id === selectedVehicleId;
            const index = Number(props['data-index']);

            return (
              <tr
                {...props}
                onClick={() => onSelectVehicle(item)}
                style={{
                  ...props.style,
                  borderBottom: '1px solid rgba(60, 64, 67, 0.15)',
                  cursor: 'pointer',
                  backgroundColor:
                    isActive ? '#ffe4e1' : index % 2 === 0 ? '#ffffff' : '#fafafa',
                  transition: 'background-color 0.15s linear'
                }}
              />
            );
          }
        }}
        fixedHeaderContent={() => (
          <tr>
            {titleTableHeader.map(title => (
              <th
                key={title.id}
                style={{
                  width: title.width,
                  border: '1px solid rgba(60, 64, 67, 0.15)',
                  padding: '3px 0',
                  background: '#d9042f',
                  color: '#FFFFFF',
                  fontSize: '12px',
                  fontWeight: 500
                }}
              >
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    whiteSpace: 'pre-line'
                  }}
                >
                  {title.name}
                </span>
              </th>
            ))}
          </tr>
        )}
        itemContent={(index, vehicle) => {
          const maxCameraCount = getMaxCameraCount(vehicle);
          const displayText =
            vehicle?.is_display_name && vehicle?.name
              ? vehicle.name
              : vehicle?.license_plate || vehicle?.device_serial || `Device ${vehicle.device_id}`;

          return (
            <>
              <td
                style={{
                  width: titleTableHeader[0].width,
                  height: 62,
                  overflow: 'hidden',
                  padding: '4px 0 6px'
                }}
              >
                <div className="cms-camera-table-cell-main">
                  <div className="cms-camera-table-main-content">
                    <VehicleTableCms
                      row={vehicle}
                      index={index}
                      displayText={displayText}
                    />
                  </div>
                  <div className="cms-camera-inline-actions">
                    {Array.from({ length: maxCameraCount }).map((_, cameraIndex) => {
                      const channel = cameraIndex + 1;
                      const active =
                        findStreamIndex(buildStreamKey(vehicle, channel)) !== -1;

                      return (
                        <CameraQuickButton
                          key={`${vehicle.device_id}-${channel}`}
                          active={active}
                          channel={channel}
                          onClick={() => toggleStream(vehicle, channel)}
                        />
                      );
                    })}
                  </div>
                </div>
              </td>
              {vehicle.debt ? (
                <td
                  colSpan={2}
                  style={{
                    width:
                      Number(titleTableHeader[1].width) +
                      Number(titleTableHeader[2].width),
                    height: 62,
                    overflow: 'hidden',
                    padding: 0
                  }}
                >
                  <div className="cms-camera-expired-cell">
                    <span>Hết hạn gói dịch vụ</span>
                  </div>
                </td>
              ) : (
                <>
                  <td
                    style={{
                      width: titleTableHeader[1].width,
                      height: 62,
                      overflow: 'hidden',
                      padding: 0
                    }}
                  >
                    <div className="cms-camera-metric-cell">
                      <span style={{ fontSize: '12px' }}>
                        {Math.floor(vehicle.speed_gps) || 0}
                      </span>
                    </div>
                  </td>
                  <td
                    style={{
                      width: titleTableHeader[2].width,
                      height: 62,
                      overflow: 'hidden',
                      padding: 0
                    }}
                  >
                    <div className="cms-camera-metric-cell cms-camera-time-cell">
                      <span style={{ fontSize: '12px' }}>
                        {getVehicleTimestamp(vehicle)}
                      </span>
                    </div>
                  </td>
                </>
              )}
            </>
          );
        }}
      />
    ) : (
      <Box className="cms-camera-empty-state">
        <VideocamIcon />
        <span>Không có phương tiện camera phù hợp</span>
      </Box>
    )}
  </Box>
));

export default CameraVehicleTable;
